import { LoggedUser } from "./common/models";
import { isNotEmpty } from "./fp";
export const CreateStorageString = (key: string) => ({
  save(value: string): boolean {
    try {
      localStorage.setItem(key, value);
      return true;
    } catch (e) {
      console.log(`CreateStorageString(${key}).save, error : `, e);
      return false;
    }
  },
  remove() {
    try {
      localStorage.removeItem(key);
    } catch (e) {
      console.log(`CreateStorageString(${key}).remove, error : `, e);
    }
  },
  get(): string | null {
    try {
      const item = localStorage.getItem(key);
      return item;
    } catch (e) {
      console.log(`CreateStorageString(${key}).get, error : `, e);
      return null;
    }
  },
  exist(): boolean {
    try {
      return isNotEmpty(localStorage.getItem(key));
    } catch (error) {
      return false;
    }
  },
});

export const createStorageItem = <T>(key: string) => {
  return {
    save: (item: T) => {
      try {
        localStorage.setItem(key, JSON.stringify(item));
      } catch (e) {
        console.log("storage.save, error : ", e);
      }
    },
    remove: () => {
      try {
        localStorage.removeItem(key);
      } catch (e) {
        console.log("storage.remove , error : ", e);
      }
    },
    get: (): T | null => {
      try {
        const str = localStorage.getItem(key);
        if (str) {
          return JSON.parse(str);
        } else {
          return null;
        }
      } catch (e) {
        console.log("storage.get, error : ", e);
        return null;
      }
    },
    exist(): boolean {
      try {
        return isNotEmpty(localStorage.getItem(key));
      } catch (error) {
        return false;
      }
    },
  };
};

export const UserStorage = createStorageItem<LoggedUser>("user");
export const RegionUrlStorage = CreateStorageString("regionUrl");
export const AppThemeStorage = CreateStorageString("theme");
export const PartnerIdStorage = CreateStorageString("partnerId");
// @ts-ignore
window.RegionUrlStorage = RegionUrlStorage;
